import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { AppSelectors } from '@redux/AppRedux';

const { Option } = Select;

const transfromOffice = officeItem => ({
  text: officeItem.name,
  value: officeItem.officeID
});

function OfficeSearch(props) {
  const { offices, value, onChange, onBlur, ...restProps } = props;

  const [data, setData] = useState(offices.map(transfromOffice));

  useEffect(() => {
    setData(offices.map(transfromOffice));
  }, [offices]);

  const searchOffices = search => {
    let filtered = offices;
    if (search) {
      filtered = offices.filter(
        ({ name }) => name.toLowerCase().indexOf(search.toLowerCase()) >= 0
      );
    }

    setData(filtered.map(transfromOffice));
  };

  return (
    <Select
      mode="default"
      labelInValue
      value={value}
      placeholder="Office"
      filterOption={false}
      onSearch={searchOffices}
      onChange={onChange}
      onBlur={onBlur}
      style={{ width: '100%' }}
      {...restProps}
    >
      {data.map(d => {
        return <Option key={d.value}>{d.text}</Option>;
      })}
    </Select>
  );
}

OfficeSearch.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  offices: PropTypes.array
};

const mapStateToProps = state => ({
  offices: AppSelectors.selectOffices(state)
});

export default connect(
  mapStateToProps,
  {}
)(OfficeSearch);
